import React from 'react'

import First_pane from './First_pane'
import Layout from '../../Layout'
import Interior from '../../Layout/Block/Interior'

const Biote_Cobalt = () => {
  return (
   <Layout>
    <First_pane />
   <Interior />
   </Layout>
  )
}

export default Biote_Cobalt